import { Box, Typography } from '@mui/material';

export type DiffStatsProps = {
  added: number;
  removed: number;
};

const DiffStats = ({ added, removed }: DiffStatsProps) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <Typography variant="caption" sx={{ color: 'var(--shell-accent-pressed)', fontWeight: 600 }}>
        +{added} слов
      </Typography>
      <Typography variant="caption" sx={{ color: 'var(--shell-semantic-error)', fontWeight: 600 }}>
        −{removed} слов
      </Typography>
    </Box>
  );
};

export default DiffStats;
